<template>
    <div>
        <div class="container">
            <div class="d-flex"> 
                <div  class="btn-home-2 mb-4 mt-3 ms-auto">
                    <button type="button" class="btn btn-outline-main" @click="returnHome">
                        <i class="fas fa-home-lg-alt"></i> Inicio
                    </button>
                </div>
            </div>
            <div id="div-modal-cxc" class="d-flex justify-content-center">
                <div id="div-cxc" class="card w-100">
                    <div class="card-header text-white h4 text-center bg-main">
                        <strong>LISTADO DE COMPRAS</strong>
                    </div>
                    <div class="card-body w-100">
                        <div class="row">
                            <!--Filtro-->
                            <div class="col-md-12 py-2">
                                <div class="row d-flex">
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mt-2">
                                        <div class="input-group">
                                            <span class="input-group-text ">Desde</span>
                                            <input type="date" aria-label="shift_date" class="form-control form-control-sm" id="init" v-model="filter.init" @change="mtdGetData"/>
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mt-2">
                                        <div class="input-group">
                                            <span class="input-group-text ">Hasta</span>
                                            <input type="date" aria-label="shift_date" class="form-control form-control-sm" id="end" v-model="filter.end" @change="mtdGetData"/>
                                        </div>
                                    </div>
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                                        <div class="input-group input-group">
                                            <span class="input-group-text text-white bg-main"
                                            ><i class="fas fa-search"></i
                                            ></span>
                                            <input
                                            @keyup="calculateData(7)"
                                            v-model="search"
                                            type="text"
                                            class="form-control form-control"
                                            placeholder="Proveedor"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--Fin Filtro-->
                            <!-- PAGINADO -->
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center mt-2 px-2">
                                <div v-if="cpData.length > 0 && showTable" class="d-flex justify-content-end">
                                    <nav aria-label="Page navigation example">
                                        <ul class="pagination mb-1">
                                            <li class="page-item">
                                                <a class="page-link page" href="javascript:void(0)" @click="backPage">Anterior</a>
                                            </li>
                                            <li v-if="limitedStepPagination[0] !== 1" class="page-item">
                                                <a :class="selectPage === 1 ? 'page-link active' : 'page-link'" href="javascript:void(0)" @click="selectedPage(1)">1</a>
                                            </li>
                                            <li v-if="limitedStepPagination[0] > 2" class="page-item disabled">
                                                <span class="page-link">...</span>
                                            </li>
    
                                            <li v-for="(item, index) in limitedStepPagination" :key="index" class="page-item">
                                                <a :class="selectPage === item ? 'page-link active' : 'page-link'" href="javascript:void(0)" @click="selectedPage(item)">{{ item }}
                                                </a>
                                            </li>
                                            <li v-if=" limitedStepPagination[limitedStepPagination.length - 1] <stepPagination.length - 1" class="page-item disabled">
                                                <span class="page-link">...</span>
                                            </li>
                                            <li v-if=" limitedStepPagination[limitedStepPagination.length - 1] !== stepPagination.length" class="page-item">
                                                <a :class="selectPage === limitedStepPagination.length + 2 ? 'page-link active':'page-link'" href="javascript:void(0)" @click="selectedPage(stepPagination.length)">{{ stepPagination.length }}
                                                </a>
                                            </li>
                                            <li class="page-item">
                                                <a class="page-link page" href="javascript:void(0)" @click="nextPage">Siguiente</a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-4" id="content-timelinetable"  v-if="showTable">
                                <table  id="tb-anular" class="table table-bordered border-main align-middle">
                                    <thead>
                                        <tr class="text-white border-white text-center bg-main" style="vertical-align: middle">
                                            <th scope="col" class="table-th-number">N°</th>
                                            <th scope="col">FECHA DE EMISIÓN</th>
                                            <th scope="col">SERIE</th>
                                            <th scope="col">RUC</th>
                                            <th scope="col">PROVEEDOR</th>
                                            <th scope="col">TOTAL</th>
                                            <th scope="col">METODO DE PAGO</th>
                                            <th scope="col" class="table-th-acciones">ACCIONES</th>
                                        </tr>
                                    </thead>

                                    <tbody class="custom-table">
                                            <tr v-if="cpData.length === 0">
                                                <td class="text-center align-middle" colspan="8">Sin Compras</td>
                                            </tr>
                                            <tr v-for="(item, index) in cpData" :key="index">
                                                <td class="text-center align-middle">{{index + 1 }}</td>
                                                <td class="text-center align-middle">{{ item.date | formatDateTime }}</td>
                                                <td class="text-center align-middle">{{ item.serie }}</td>
                                                <td class="text-center align-middle">{{ item.provider_ruc ? item.provider_ruc : '-' }}</td>
                                                <td class="text-center align-middle">{{ item.provider_name}}</td>
                                                <td class="text-center align-middle">{{ item.total }}</td>
                                                <td class="text-center align-middle">{{ item.metodo_name }}</td>
                                                <td class="text-center align-middle"> 
                                                    <div class="d-flex d-md-block justify-content-center">
                                                        <button 
                                                            @click="verDetalle(item)" class="btn btn-primary btn-sm rounded-circle bootom me-1">
                                                            <i class="fas fa-eye"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <cModalDetalleCompraVue :id="modal.id" :payload="modal.payload" :title="modal.title"
        :boo_modal="modal.modal_form" @closeModal="closeModal"/>
        <SweetAlert :swal="swal" ref="SweetAlert" />
    </div>
</template>

<script>
  import {mapActions} from "vuex";
  import moment from "moment";
  import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
  import cModalDetalleCompraVue from '../Modals/cModalDetalleCompra.vue'

export default {
    name: "listadoCompras",
    components: {
        SweetAlert,
        cModalDetalleCompraVue
    },
    data() {
        return {
            swal: null,
            search: "",
            dataShow: [],
            dataCompras: [],
            showTable: false,
            filter: {
                init: null,
                end: null,
            },
            modal: {
                title: "",
                modal_form: false,
                payload: [],
                id: null,
            },
            //Pag
            page: 0,
            selectPage: 1,
            stepPagination: [],
            totalPagesToShow: 4,
            action: "",
        };
    },
    watch: {
        selectPage() {
            this.calculateData(7);
        },
    },
    computed: {
        cpData() {
            return this.dataShow;
        },
        limitedStepPagination() {
            const totalPages = this.stepPagination.length;
            const currentPage = this.selectPage;

            let startPage = 1;
            let endPage = totalPages;
            if (totalPages > this.totalPagesToShow) {
                const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

                if (currentPage > halfPagesToShow) {
                    startPage = currentPage - halfPagesToShow;
                    endPage = currentPage + halfPagesToShow - 1;

                    if (endPage > totalPages) {
                        endPage = totalPages;
                        startPage = totalPages - this.totalPagesToShow + 1;
                    }
                } else {
                    endPage = this.totalPagesToShow;
                }
            }

            return Array.from({
                    length: endPage - startPage + 1,
                },
                (_, i) => startPage + i
            );
        },
    },
    created() {
        moment.locale("es");
        this.filter.end =
            moment().format("L").substr(6, 4) +
            "-" +
            moment().format("L").substr(3, 2) +
            "-" +
            moment().format("L").substr(0, 2);
        this.filter.init = this.filter.end;
        this.mtdGetData();
    },
    methods: {
        ...mapActions(["get", "post"]),

        mtdGetData: function () {
            this.post({
                url: this.$store.getters.get__url + "/Logis/purchase/mtdGetListado",
                token: this.$store.getters.get__token,
                params: {
                    init: this.filter.init,
                    end: this.filter.end,
                    campu_id: this.$store.getters.get__campus,
                },
            })
            .then((response) => {
                this.dataCompras = response.data;
                if (this.dataCompras.length === 0) {
                    this.showTable = false;
                    this.$refs.SweetAlert.showWarning("Sin Datos");
                } else {
                    this.showTable = true;
                    this.calculateData(7);
                }
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
            
        },

        calculateData(items) {
            if (!this.dataCompras || !this.dataCompras.length) {
                return (this.dataShow = []);
            }
            let filteredData = this.dataCompras;
            let indexInitial = this.selectPage;
            if (this.search.length >= 2 && this.search != "") {
                let query = this.search.toString().toUpperCase();
                filteredData = this.dataCompras.filter((element) => {
                    let name = element.provider_name.toString().toUpperCase();
                    return name.includes(query);
                });
                indexInitial = 1;
            }
            let totalPages = Math.ceil(filteredData.length / items);
            this.stepPagination = Array.from({
                    length: totalPages,
                },
                (_, index) => index + 1
            );

            let startIndex = (indexInitial - 1) * items;
            let endIndex = startIndex + (items - 1);
            this.dataShow = filteredData.slice(startIndex, endIndex + 1);
            this.count = this.count + 1;
        },

        //Modal Detalle
        verDetalle(item) {
            this.modal.title = "Detalle de Compra";
            this.modal.id = item.id;
            this.modal.payload = item.detail;
            this.modal.modal_form = true;
        },

        closeModal: function () {
            this.modal = {
                title: '',
                modal_form: false,
                id: null,
                payload: [],
            }
        },


        //Paginacion
        backPage() {
            this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
        },
        nextPage() {
            this.selectPage =
                this.selectPage < this.stepPagination.length ?
                this.selectPage + 1 :
                this.stepPagination.length;
        },
        selectedPage(page) {
            this.selectPage = page;
        },
        returnHome: function () {
            this.$emit("returnHome");
        },
    },
    filters: {
        formatDate(date) {
            return date != null ? moment(date).format("DD/MM/YYYY") : "-";
        },
        formatDateTime(dateTime) {
            return dateTime != null ? moment(dateTime).format("DD/MM/YYYY HH:mm") : "-";
        },
    },
};
</script>

<style scoped>
.custom-table th,
.custom-table td {
    font-size: 12px;
}
.nowrap {
  white-space: nowrap;
}
.bootom {
  background-color: #2c3c5c !important; 
  border: 0.5px solid #2c3c5c !important;
}
</style>
